import { create } from "zustand";

interface Toast {
  id: string;
  description: string;
  variant?: "default" | "destructive" | "success";
}

interface ToastState {
  toasts: Toast[];
  toast: (options: { description: string; variant?: Toast["variant"] }) => void;
  dismiss: (id: string) => void;
}

const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  toast: (options) => {
    const id = Math.random().toString(36).substring(2, 9);
    const newToast: Toast = {
      id,
      description: options.description,
      variant: options.variant || "default",
    };

    set((state) => ({
      toasts: [...state.toasts, newToast],
    }));

    // Auto dismiss after 5 seconds
    setTimeout(() => {
      set((state) => ({
        toasts: state.toasts.filter((t) => t.id !== id),
      }));
    }, 5000);
  },
  dismiss: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    }));
  },
}));

export function useToast() {
  const toasts = useToastStore((state) => state.toasts);
  const toast = useToastStore((state) => state.toast);
  const dismiss = useToastStore((state) => state.dismiss);

  return { toasts, toast, dismiss };
}
